<template>
  <div class="row">
  <span class="d-none d-sm-block w-100">
    <div class="main-category-bar d-flex mb-3 bg-white pl-2">
      <span v-for="(item,index) of data" :key="index">
        <n-button v-if="index<7"
                  :key="item.id"
                  type="default"
                  link
                  @click="sendTagId(item.id)"
                  v-bind:class="{active:activeId==item.id}"
        >
            <span>{{item.name|textTrans}}</span>
        </n-button>

      </span>
      <drop-down
          class="nav-item dropdown"
          :title="$t('message').group.index_hot_categorymenu"
          style="margin-top:3px;"
          tag="span">
        <span v-for="(item,index) of data" :key="index">
          <a
              class="dropdown-item"
              v-if="index>=7"
              :key="item.id" href="#"
              @click="sendTagId(item.id)">{{item.name|textTrans}}</a>
        </span>
      </drop-down>
    </div>
  </span>
    <span class="d-block d-sm-none">
    <div class="main-category-bar d-flex">
      <span v-for="(item,index) of data" :key="index">
        <n-button v-if="index<3"
                  :key="item.id"
                  type="default"
                  link
                  @click="sendTagId(item.id)"
                  v-bind:class="{active:activeId==item.id}"
        >
            <span>{{item.name|textTrans}}</span>
        </n-button>
      </span>
      <drop-down
          class="nav-item dropdown"
          title="全部"
          style="margin-top:3px;"
          tag="span">
        <span v-for="(item,index) of data" :key="index">
          <a
              class="dropdown-item"
              v-if="index>=3 && item.visible==1"
              :key="item.id" href="#"
              @click="sendTagId(item.id)">{{item.name}}</a>
        </span>
      </drop-down>
    </div>
  </span>
  </div>
</template>
<script>
import {
  Button,
  DropDown
} from '@/components';
import {textTrans} from '@/directives/textTrans.js';

export default {
  name: 'main-category-bar',
  props: {
    activeId:Number,
    data:Array
  },
  components: {
    [Button.name]: Button,
    DropDown
  },
  data() {
    return {

    }
  },
  methods:{
    sendTagId(id){
      this.$emit('get-tagid',id)
    }
  },
  filters: {
    textTrans(string) {
      return textTrans(string);
    }
  }
};
</script>
<style>
.main-category-bar span{
  font-size: 1rem;
  font-weight: 500;
  color: #333537;
}

.main-category-bar button{
  background-color: #f5f5f5 !important;
  margin-right:0.4rem;
}
.main-category-bar button:hover{
  background-color: aliceblue !important

}
.main-category-bar .active ,.main-category-bar .active span{
  text-align: center;
  color:#0ba0ce !important;
  background-color: aliceblue!important;
}
#WxcColor  .main-category-bar .active {
  color: #056de8 !important;
  background-color: rgb(5 109 232 / 8%) !important;
}
#WxcColor  .main-category-bar .active span {

  color: #056de8 !important;
}
.main-category-bar .active{
  cursor:default !important;
}
</style>
